module.exports = __webpack_public_path__ + "static/media/cumulative.94f80d49.png";